import { cn } from "@/lib/utils";

/**
 * Shared "BETA" pill. Single source of truth for the badge used by the
 * interaction-mode picker and the provider picker.
 */
export function BetaBadge({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        "inline-flex shrink-0 items-center rounded-full px-1.5 py-0.5 text-[10px] font-semibold tracking-wide",
        className,
      )}
      style={{ background: "#ECECEF", color: "#5F5E5A" }}
    >
      BETA
    </span>
  );
}